module.exports = "/static/media/eSIM.bddd30e1.png";